

/* ===================================================
   OVRA Liquid Menu Tilt
=================================================== */

document.addEventListener("DOMContentLoaded", () => {

    const drawer = document.querySelector("#menu-drawer");
    if (!drawer) return;

    const items = drawer.querySelectorAll(".menu-drawer__menu-item");

    if (!items.length) return;

    let rect;

    function updateRect(){
        rect = drawer.getBoundingClientRect();
    }

    updateRect();

    window.addEventListener("resize", updateRect);

    drawer.addEventListener("pointermove",(e)=>{

        const x = (e.clientX - rect.left) / rect.width;
        const y = (e.clientY - rect.top) / rect.height;

        const rotateY = (x-.5)*4;   // max ±2°
        const rotateX = (.5-y)*4;   // max ±2°

        items.forEach((item,index)=>{

            const depth = 1 + index*0.08;

            item.style.transform = `
                perspective(900px)
                rotateX(${rotateX/depth}deg)
                rotateY(${rotateY/depth}deg)
                translateZ(0)
            `;

        });

    });

    drawer.addEventListener("pointerleave",()=>{

        items.forEach(item=>{

            item.style.transform = `
                perspective(900px)
                rotateX(0deg)
                rotateY(0deg)
            `;

        });

    });

});




/* ===================================================
   OVRA Gyroscope Lighting
=================================================== */

document.addEventListener("DOMContentLoaded", () => {

    const drawer = document.querySelector("#menu-drawer");
    if (!drawer) return;

    function updateLight(beta, gamma){

        // Clamp values
        beta = Math.max(-30, Math.min(30, beta));
        gamma = Math.max(-30, Math.min(30, gamma));

        const x = 50 + (gamma / 30) * 18;
        const y = 35 + (beta / 30) * 18;

        drawer.style.setProperty("--ovra-light-x", `${x}%`);
        drawer.style.setProperty("--ovra-light-y", `${y}%`);
    }

    function startMotion(){

        window.addEventListener("deviceorientation", e => {

            if(e.beta == null || e.gamma == null) return;

            updateLight(e.beta, e.gamma);

        });

    }

    // iOS 13+
    if (typeof DeviceOrientationEvent !== "undefined"
        && typeof DeviceOrientationEvent.requestPermission === "function") {

        document.addEventListener("click", () => {

            DeviceOrientationEvent.requestPermission()
                .then(permission => {

                    if(permission === "granted"){
                        startMotion();
                    }

                })
                .catch(()=>{});

        }, { once:true });

    } else {

        startMotion();

    }

});